import { Search, BarChart3, Key, PenTool, Hammer, Sparkles, Flag } from "lucide-react";

export const OP_STATUS = { aperta: "Operazione aperta", in_corso: "Operazione in corso", conclusa: "Operazione conclusa" };

export const PHASES = [
  ["individuata", "Opportunità individuata"],
  ["acquisizione", "Acquisizione"],
  ["progettazione", "Progettazione"],
  ["ristrutturazione", "Ristrutturazione"],
  ["commercializzazione", "Commercializzazione"],
  ["conclusa", "Operazione conclusa"],
];

export const METHOD_STEPS = [
  { n: "01", title: "Scouting", text: "Individuazione dell'opportunità immobiliare.", icon: Search },
  { n: "02", title: "Analisi", text: "Valutazione economica e studio della trasformazione.", icon: BarChart3 },
  { n: "03", title: "Acquisizione", text: "Strutturazione dell'operazione.", icon: Key },
  { n: "04", title: "Progettazione", text: "Definizione della nuova distribuzione e dell'interior design.", icon: PenTool },
  { n: "05", title: "Ristrutturazione", text: "Coordinamento e gestione dell'intervento.", icon: Hammer },
  { n: "06", title: "Valorizzazione", text: "Preparazione dell'immobile per il mercato.", icon: Sparkles },
  { n: "07", title: "Exit", text: "Commercializzazione e conclusione dell'operazione.", icon: Flag },
];

export const MEDIA_TABS = [
  { key: "images_before", label: "Prima", empty: "Fotografie dello stato attuale in aggiornamento" },
  { key: "project", label: "Progetto", empty: "Rendering in aggiornamento" },
  { key: "images_site", label: "Cantiere", empty: "Avanzamento lavori disponibile prossimamente" },
  { key: "images_result", label: "Risultato", empty: "Risultato finale disponibile al termine dell'intervento" },
];

export const FLOW = ["Acquistare", "Trasformare", "Valorizzare", "Vendere"];
